import React from 'react';
import { SVGIconProps } from './props';

const BottomTriangleSVGIcon = (props: SVGIconProps) => {
    return (
        <span className={props.className}>
            <svg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M5 8L0.669873 0.499999L9.33013 0.5L5 8Z' fill={props.front_fill ?? '#0050C8'} />
            </svg>
        </span>
    );
};

export default BottomTriangleSVGIcon;
